/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivationFunnelE4BreakdownFromJSON, ActivationFunnelE4BreakdownToJSON } from './ActivationFunnelE4Breakdown';
import { FunnelStageE4FromJSON, FunnelStageE4ToJSON } from './FunnelStageE4';
import { FunnelStageE5FromJSON, FunnelStageE5ToJSON } from './FunnelStageE5';
/**
 * Check if a given object implements the FunnelMetricsResponse interface.
 */
export function instanceOfFunnelMetricsResponse(value) {
    if (!('e4' in value) || value['e4'] === undefined)
        return false;
    if (!('e5' in value) || value['e5'] === undefined)
        return false;
    return true;
}
export function FunnelMetricsResponseFromJSON(json) {
    return FunnelMetricsResponseFromJSONTyped(json, false);
}
export function FunnelMetricsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'e4': FunnelStageE4FromJSON(json['e4']),
        'e4Breakdown': json['e4Breakdown'] == null ? undefined : ActivationFunnelE4BreakdownFromJSON(json['e4Breakdown']),
        'e5': FunnelStageE5FromJSON(json['e5']),
    };
}
export function FunnelMetricsResponseToJSON(json) {
    return FunnelMetricsResponseToJSONTyped(json, false);
}
export function FunnelMetricsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'e4': FunnelStageE4ToJSON(value['e4']),
        'e4Breakdown': ActivationFunnelE4BreakdownToJSON(value['e4Breakdown']),
        'e5': FunnelStageE5ToJSON(value['e5']),
    };
}
